export const CHIP_LIST_LABELS = {
    SALE: { className: 'sale-label', content: 'Sale' },
    LIMITED_SIZE: { className: 'limited-label', content: 'Limited Sizes' },
    SOLD_OUT: { className: 'sold-out-label', content: 'Sold Out' }
}